var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"id":"advertise-richTextPreview","title":"富文本预览","visible":_vm.show,"top":"10vh"},on:{"update:visible":function($event){_vm.show=$event}}},[_c('iframe',{attrs:{"src":_vm.iframe,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }